import { Socket, io } from "socket.io-client";
import Cookies from "js-cookie";
import { SocketEvents } from "./events";
import userMobx from "../mobx/user";

export class SocketService {
    socket: Socket;

    constructor() {
        const token = userMobx.getToken()
        this.socket = io(process.env.REACT_APP_PUBLIC_API_URL ?? "",
            {
                auth: {
                    token: `Bearer ${token}`
                },
                // Reconnexion persistante : l'ancienne config (3 tentatives,
                // 50s de delai) abandonnait vite -> plus aucun message temps
                // reel apres une coupure reseau/veille, d'ou le besoin de
                // rafraichir la page manuellement.
                reconnection: true,
                reconnectionDelay: 2000,
                reconnectionDelayMax: 10000,
                reconnectionAttempts: Infinity,
                timeout: 20000,
                transports: ['websocket'],
            });
        const socketEvents = new SocketEvents()
        let hasConnectedOnce = false
        this.socket.on("connect", () => {
            console.log("connected")
            // A chaque reconnexion (pas la 1re), on resynchronise la liste des
            // conversations pour rattraper les messages emis pendant la coupure.
            if (hasConnectedOnce) socketEvents.resyncMessages()
            hasConnectedOnce = true
        })
        this.socket.on('message:new', data => socketEvents.getMessage(data))
        this.socket.on('message:read', data => socketEvents.updateMessage(data))
        this.socket.on('media:new', data => socketEvents.getNewMedia(data))
    }

    on(event: string, callback: (...args: any[]) => void): SocketService {
        this.socket.on(event, callback);
        return this
    }

    emit(event: string, data: any): SocketService {
        this.socket.emit(event, data);
        return this
    }
}
const socketServiceInstance = new SocketService();

Object.freeze(socketServiceInstance);
export default socketServiceInstance;